import angular from 'angular';

import { ActivityReportComponent } from './components/activity-report.component';
import { PeriodReportComponent } from './components/period-report.component';

import { ActivityReportService } from './services/activity-report.service';
import { PeriodReportService } from './services/period-report.service';

const reports = angular.module('reports',
    [
        'ngResource',
        'ngSanitize',
        'ui.select', 
        'commons',
        'activities',
        'publicLink'
    ]
);

reports.component('activityReport', ActivityReportComponent);
reports.component('periodReport', PeriodReportComponent);

reports.service('ActivityReport', ActivityReportService);
reports.service('PeriodReport', PeriodReportService);